import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const DATE_RANGE_MESSAGE = 'La fecha de fin no puede ser anterior a la de inicio.';

const dayOf = (value: unknown): number | null => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value as string);
  return isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
};

/** Validador de grupo: error `dateRange` si alguna pareja [inicio, fin] tiene el fin antes del inicio (por día). */
export function dateRangeValidator(pairs: Array<[string, string]> = [['startDate', 'endDate']]): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    for (const [startKey, endKey] of pairs) {
      const start = dayOf(group.get(startKey)?.value);
      const end = dayOf(group.get(endKey)?.value);
      if (start !== null && end !== null && end < start) {
        return { dateRange: { start: startKey, end: endKey } };
      }
    }
    return null;
  };
}

/** true si algún grupo del árbol de controles tiene un rango de fechas invertido. */
export function hasDateRangeError(control: AbstractControl): boolean {
  if (control.hasError('dateRange')) return true;
  if (control instanceof FormGroup) return Object.values(control.controls).some(hasDateRangeError);
  if (control instanceof FormArray) return control.controls.some(hasDateRangeError);
  return false;
}
